import './video-actions.component.ajscss';

import { IVideoconferenceService } from '@agent/core/channel-digit/videoconference/videoconference.service';
import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './video-actions.component.ajs.html';

class VideoActionsCtrl implements IComponentController {
  responseId: string;

  constructor(private readonly videoconferenceService: IVideoconferenceService) {}

  $onInit() {}

  hangUp(): void {
    this.videoconferenceService.hangUp();
  }

  isCallInProcess(): boolean {
    return this.videoconferenceService.callInProcess;
  }
}

export class VideoActions implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  };
  controller = ['videoconference', VideoActionsCtrl];
}

export default 'contactVideoActions';
